import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type {
  BunkerFreshWater,
  BunkerPayload,
} from "../utils/types/bunkerFreshWater";

interface BunkerFreshWaterApiResponse {
  data: BunkerFreshWater[];
}

export const fetchBunkerFreshWater = async (
  berthId?: string,
  jobId?: string
) => {
  const params: { [key: string]: any } = {};
  // Only add the parameters that are provided
  if (berthId) {
    params.bearthId = berthId; // Fixed: was "bearthId" (typo)
    params.jobId = jobId;
  }

  if (jobId) {
    params.jobId = jobId;
  }
  const response = await axiosServices.get<BunkerFreshWaterApiResponse>(
    "/bunkersfreshwater",
    {
      params,
    }
  );
  const res = response.data;
  return convertToCamelCase<BunkerFreshWater[]>(res.data);
};

export const updateBunkerFreshWater = async (
  id: string,
  berthId?: string,
  jobId?: string,
  data?: {
    [key: string]: any;
    bunkersFreshWaterId: string;
  }
) => {
  const params: { [key: string]: any } = {};
  if (data && jobId) {
    data.job_id = jobId; // Fixed: was "job_id" (typo)
  }
  if (berthId) {
    params.berthId = berthId; // Fixed: was "bearthId" (typo)
  }
  const inputData = convertToSnakeCase(data);
  await axiosServices.put(`/bunkersfreshwater/${id}`, inputData, {
    params,
  });
};

export const deleteBunkerFreshWater = async (data: {
  id: string;
  berthId: string;
}) => {
  const response = await axiosServices.delete(`bunkersfreshwater/${data.id}`, {
    params: {
      berthId: data.berthId,
    },
  });
  return response.data;
};

export const addBunker = async (data: BunkerPayload) => {
  const payloadData = convertToSnakeCase(data);
  const response = await axiosServices.post<{ data: BunkerFreshWater }>(
    "/bunkersfreshwater",
    payloadData,
    {
      params: {
        berthId: data.berthId,
      },
    }
  );
  return convertToCamelCase<BunkerFreshWater>(response.data.data);
};

export const moveBunker = async (id: string, berthId: string) => {
  await axiosServices.put(`/bunkersfreshwater/${id}`, {
    berth_id: berthId,
  });
};
